var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 3,
    viewBox: "0 0 12 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.5C9.375 2.13281 9.86719 2.625 10.5 2.625C11.1094 2.625 11.625 2.13281 11.625 1.5C11.625 0.890625 11.1094 0.375 10.5 0.375C9.86719 0.375 9.375 0.890625 9.375 1.5ZM2.625 1.5C2.625 0.890625 2.10938 0.375 1.5 0.375C0.867188 0.375 0.375 0.890625 0.375 1.5C0.375 2.13281 0.867188 2.625 1.5 2.625C2.10938 2.625 2.625 2.13281 2.625 1.5ZM7.125 1.5C7.125 0.890625 6.60938 0.375 6 0.375C5.36719 0.375 4.875 0.890625 4.875 1.5C4.875 2.13281 5.36719 2.625 6 2.625C6.60938 2.625 7.125 2.13281 7.125 1.5Z",
    fill: "#E85F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b4a5386dc7dec36f9b7ea692f617ce2c.svg";
export { ForwardRef as ReactComponent };